import React, { useEffect, useState } from 'react'

const Header = () => {    
    return (
        <header className='header'>
            <h1>DJ</h1>    
            <h1>xTurbo</h1>    
        </header>
    )
}


export default Header;
